module.exports = __webpack_public_path__ + "img/价格监测点.98559b05.png";